import { render, staticRenderFns } from "./arbitrationExpert.vue?vue&type=template&id=9d8bbb44"
import script from "./arbitrationExpert.vue?vue&type=script&lang=js"
export * from "./arbitrationExpert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports